import { UsersStateType } from './types';

import { Pagination, UsersActionType } from 'enums';
import { UsersActionReturnType } from 'state/actions/users';
import { UserType } from 'state/reducers/auth/types';

const initState: UsersStateType = {
  isLoading: false,
  users: [],
  search: '',
  page: Pagination.START_PAGE,
  certainUser: {} as UserType,
};

export const usersReducer = (
  // eslint-disable-next-line default-param-last
  state: UsersStateType = initState,
  action: UsersActionReturnType,
): UsersStateType => {
  switch (action.type) {
    case UsersActionType.SET_USERS:
      return { ...state, users: action.users };
    case UsersActionType.SET_USERS_AFTER_SCROLL:
      return { ...state, users: [...state.users, ...action.users] };
    case UsersActionType.SEARCH_USER:
      return { ...state, search: action.search };
    case UsersActionType.SET_PAGINATION:
      return { ...state, count: action.pagination.count, page: action.pagination.page };
    case UsersActionType.SET_USERS_LOADING_STATUS:
      return { ...state, isLoading: action.isLoading };
    case UsersActionType.SET_CERTAIN_USER:
      return { ...state, certainUser: action.certainUser };
    default:
      return state;
  }
};
